var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediumPriority(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_897_51262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.7832 0C7.77174 0 7.03029 0.411557 6.3132 0.80958C5.65183 1.17668 5.02712 1.52344 4.21289 1.52344C3.4432 1.52344 2.64799 1.12201 2.30859 0.928002V0H1.54688V13H2.30859V7.88267C2.7854 8.11291 3.49218 8.37891 4.21289 8.37891C5.22433 8.37891 5.96583 7.96735 6.68289 7.56933C7.34427 7.20223 7.969 6.85547 8.7832 6.85547C9.79301 6.85547 10.847 7.5465 10.8571 7.55323L11.4492 7.94798V0.938742C10.666 0.421891 9.71016 0 8.7832 0ZM10.6875 6.58996C10.2107 6.35972 9.50392 6.09375 8.7832 6.09375C7.77174 6.09375 7.03029 6.50531 6.3132 6.90333C5.65183 7.27043 5.02712 7.61719 4.21289 7.61719C3.44307 7.61719 2.64771 7.21563 2.30859 7.02178V1.78892C2.7854 2.01916 3.49218 2.28516 4.21289 2.28516C5.22433 2.28516 5.96583 1.8736 6.68289 1.47558C7.34427 1.10848 7.969 0.761719 8.7832 0.761719C9.55295 0.761719 10.3484 1.16325 10.6875 1.35713V6.58996Z",
    fill: "#003DC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.76131 7.87007L2.39289 7.18586H2.05078V1.71217L4.44552 2.05428L7.18236 1.02796L9.23499 0.34375L10.2613 1.02796H10.9455V6.84375L10.2613 6.50165H7.86657L6.49815 7.52796L3.76131 7.87007Z",
    fill: "#003DC8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_897_51262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumPriority);
export default __webpack_public_path__ + "static/media/MediumPriority.0af6368ec725dbdeebf0a8af0e198e29.svg";
export { ForwardRef as ReactComponent };